import {
  GridColumnHeaderParams,
  GridRenderCellParams,
} from "@mui/x-data-grid-pro";

import { SmartGroupData } from "pages/Dashboard/components/SmartGroupsTable/types";

import { SchemaEntry } from "features/ui/MaterialTable";

import { actionsColumn } from "./actionsColumn";
import { allTimeCountColumn } from "./allTimeCountColumn";
import { chartColumn } from "./chartColumn";
import { filteredCountColumn } from "./filteredCountColumn";
import { groupNameColumn } from "./groupNameColumn";
import { projectIDColumn } from "./projectIDColumn";
import {
  ColumnOrderConfig,
  SmartGroupColumnContext,
  SmartGroupColumnDefinition,
  SmartGroupColumnId,
} from "./types";

export * from "./types";

export const COLUMN_REGISTRY: Record<
  SmartGroupColumnId,
  SmartGroupColumnDefinition
> = {
  [SmartGroupColumnId.GROUP_NAME]: groupNameColumn,
  [SmartGroupColumnId.FILTERED_COUNT]: filteredCountColumn,
  [SmartGroupColumnId.CHART]: chartColumn,
  [SmartGroupColumnId.ALL_TIME_COUNT]: allTimeCountColumn,
  [SmartGroupColumnId.PROJECT_ID]: projectIDColumn,
  [SmartGroupColumnId.ACTIONS]: actionsColumn,
};

export const DEFAULT_COLUMN_ORDER: ColumnOrderConfig = [
  SmartGroupColumnId.GROUP_NAME,
  SmartGroupColumnId.FILTERED_COUNT,
  SmartGroupColumnId.CHART,
  SmartGroupColumnId.ALL_TIME_COUNT,
  SmartGroupColumnId.PROJECT_ID,
  SmartGroupColumnId.ACTIONS,
];

export const getOrderedColumnDefinitions = (
  order: ColumnOrderConfig | string[] = DEFAULT_COLUMN_ORDER
): SmartGroupColumnDefinition[] =>
  order
    .map((columnId) => COLUMN_REGISTRY[columnId as SmartGroupColumnId])
    .filter((column): column is SmartGroupColumnDefinition => !!column);

export const buildSchemaFromColumns = (
  columns: SmartGroupColumnDefinition[],
  context: SmartGroupColumnContext
): SchemaEntry[] => columns.map((column) => column.getSchema(context));

export const createRenderHeader = (
  columns: SmartGroupColumnDefinition[],
  context: SmartGroupColumnContext
) => {
  // map of accessor to column definition for quick lookup
  const accessorToColumn = new Map<string, SmartGroupColumnDefinition>();
  columns.forEach((column) => {
    const schema = column.getSchema(context);
    accessorToColumn.set(schema.accessor, column);
  });

  return (params: GridColumnHeaderParams) => {
    const column = accessorToColumn.get(params.field);
    if (!column) return null;

    return column.renderHeader({ context });
  };
};

export const createFormatCell = (
  columns: SmartGroupColumnDefinition[],
  context: SmartGroupColumnContext
) => {
  // map of accessor to column definition for quick lookup
  const accessorToColumn = new Map<string, SmartGroupColumnDefinition>();
  columns.forEach((column) => {
    const schema = column.getSchema(context);
    accessorToColumn.set(schema.accessor, column);
  });

  return (params: GridRenderCellParams) => {
    const column = accessorToColumn.get(params.field);
    if (!column) return params.value;

    const row = params.row as SmartGroupData;

    return column.renderCell({ params, row, context });
  };
};
